import React from 'react';
import { StyleSheet, Text, View } from 'react-native';
import { Favourite } from '@views/shared/Favourite';
import { globalStyles } from '@views/shared/styles';

interface Props {
  count?: number;
  onPress?: () => void;
}

const styles = StyleSheet.create({
  container: {
    position: 'absolute',
    top: -1,
    left: 0,
    right: 0,
    bottom: 0,
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1,
  },
});

export function FavouriteCount({ count = 0, onPress }: Props) {
  const hasCount = count > 0;
  return (
    <View>
      {hasCount ? (
        <View pointerEvents="none" style={styles.container}>
          <Text style={globalStyles.favCount}>{count}</Text>
        </View>
      ) : null}
      <Favourite
        onPress={hasCount ? onPress : undefined}
        selected={hasCount}
        size={30}
      />
    </View>
  );
}
